import { FC, ReactNode, useMemo } from 'react'
import { DataLakeProvider, environment, useTenantSettings } from 'react-common'
import i18n from '@/plugins/i18n'
import { isOpenCatalog } from '@/utils/isOpenCatalog'
import { isPublicCertificate } from '@/utils/isPublicCertificate'

export const CustomDataLakeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const sessionDuration = useTenantSettings<number>('lms.datalake.sessionDuration', true)

  const settings = useMemo(() => ({ sessionDuration }), [sessionDuration])

  return (
    <DataLakeProvider
      appVersion={environment().VITE_RELEASE_NUMBER}
      appName="learner"
      locale={i18n.language}
      isPublic={isOpenCatalog() || isPublicCertificate()}
      settings={settings}
    >
      {children}
    </DataLakeProvider>
  )
}
